"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const button_1 = __importStar(require("@kyruus/button"));
const intl_1 = require("@kyruus/intl");
const react_1 = require("@xstate/react");
const react_2 = __importDefault(require("react"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const constants_1 = require("../../lib/constants");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const utils_1 = require("../../../lib/utils");
const useManageAppointmentContext_1 = require("../../hooks/useManageAppointmentContext");
const Tracking_1 = require("../../lib/constants/Tracking");
/**
 * Function to adapt reschedule reasons to select options
 *
 * @param reasons {RescheduleReason[]} - Reschedule reasons
 * @returns
 */
const rescheduleReasontoSelectAdapter = (reasons) => reasons === null || reasons === void 0 ? void 0 : reasons.map((reason) => ({
    label: reason.text,
    value: reason.code
}));
/**
 * Component to display RescheduleReason
 *
 * @component
 * @param props {RescheduleReasonProps} - Props for RescheduleReason component
 * @returns
 */
const RescheduleReason = (props) => {
    var _a;
    const [state, send] = (0, react_1.useService)(props.service);
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    const onReasonChange = (event) => {
        const selectedReason = state.context.rescheduleReasons.find((reason) => reason.code === event.currentTarget.value);
        if (selectedReason) {
            send({
                type: constants_1.events.UPDATE_REASON,
                data: selectedReason
            });
            track(Tracking_1.userEvents.RESCHEDULE_REASON_SELECTED, {
                reason: selectedReason.text
            });
        }
        return event.currentTarget.value;
    };
    const handleKeepOriginalAppointment = (event) => {
        track(Tracking_1.userEvents.KEEP_ORIGINAL_APPOINTMENT_CLICKED);
        send(constants_1.events.KEEP_ORIGINAL_APPOINTMENT);
        return event;
    };
    const handleBookAppointment = (event) => {
        track(Tracking_1.userEvents.BOOK_APPOINTMENT_CLICKED);
        send(constants_1.events.RESCHEDULE_APPOINTMENT);
        return event;
    };
    const isAppointmentRescheduling = state.matches(constants_1.states.appointmentRescheduling);
    const warningBanner = state.matches(constants_1.states.appointmentReschedulingFailed) ? (react_2.default.createElement(styles_1.StyledWarningBanner, { type: "warning", icon: "!" },
        react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.reschedulingFailedAlert)))) : null;
    const selectedAppointmentTime = (0, utils_1.getAppointmentDate)(state.context.selectedSlot);
    return (react_2.default.createElement(styles_1.RescheduleReasonContainer, { "data-testid": "select-action-component", isDesktop: aboveMd },
        react_2.default.createElement(styles_1.SelectReasonContent, null,
            aboveMd && warningBanner,
            react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.selectReasonAlert)),
            react_2.default.createElement(styles_1.StyledSelect, { onChange: onReasonChange, value: ((_a = state.context.selectedRescheduleReason) === null || _a === void 0 ? void 0 : _a.code) || '', placeholder: props.intl.formatMessage(messages_1.default.reasonPlaceholder), disabled: false, name: 'rescheduleReason', label: props.intl.formatMessage(messages_1.default.reasonLabel), options: rescheduleReasontoSelectAdapter(state.context.rescheduleReasons), "data-testid": "rescheduleReason" })),
        react_2.default.createElement(styles_1.ReviewReasonContent, null,
            react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.reviewAppointmentTime)),
            react_2.default.createElement("p", null,
                selectedAppointmentTime.formattedDate,
                " -",
                ' ',
                selectedAppointmentTime.formattedTime)),
        react_2.default.createElement(styles_1.StyledButtonGroup, { isDesktop: aboveMd },
            !aboveMd && warningBanner,
            react_2.default.createElement(button_1.default, { mode: "ghost", onClick: handleKeepOriginalAppointment, disabled: isAppointmentRescheduling, "data-testid": "keepOriginalAppointmentBtn" },
                react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.keepOriginalAppointment))),
            react_2.default.createElement(button_1.ButtonWithSpinner, { onClick: handleBookAppointment, showSpinner: isAppointmentRescheduling, disabled: isAppointmentRescheduling, "data-testid": "bookAppointmentBtn" },
                react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.bookAppointment))))));
};
exports.default = (0, intl_1.injectIntl)(RescheduleReason);
//# sourceMappingURL=RescheduleReason.js.map